import { jsx as _jsx } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import Link from "next/link";
import Logo from "/public/static/logo/_Logo_.svg";
const GNBLogo = (param)=>{
    let { variant ="desktop" , className  } = param;
    const handleClick = ()=>{
        mixpanelEvent("Logo Clicked");
    };
    return /*#__PURE__*/ _jsx("h1", {
        children: /*#__PURE__*/ _jsx(Link, {
            href: "/",
            onClick: handleClick,
            className: cn("flex items-center shrink-0", variant === "desktop" ? "h-[32px]" : "h-[25px]", className),
            children: /*#__PURE__*/ _jsx(Logo, {
                className: "w-auto h-full",
                "aria-label": "쏠북로고"
            })
        })
    });
};
export default GNBLogo;
